var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button t-text t-text--small t-bold u-white u-inline-block",style:({backgroundColor: _vm.color}),attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }